export const LAYOUT_CONSTANTS = {
  standard: "standard",
  fullscreen: "fullscreen",
  minimal: "minimal",
  empty: "empty",
} as const;

export type LayoutType = keyof typeof LAYOUT_CONSTANTS;
